"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _quizz = require("../contexts/quizz");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var InputRadio = function InputRadio(_ref) {
  var choice = _ref.choice,
      handleChange = _ref.handleChange,
      checked = _ref.checked; //console.log("plop", choice);

  return _react["default"].createElement("div", {
    className: "radio",
    key: choice.id
  }, _react["default"].createElement("label", null, _react["default"].createElement("input", {
    type: "radio",
    value: choice.id,
    checked: checked,
    onChange: function onChange(event) {
      return handleChange(event);
    }
  }), choice.label));
};

var RadioForm = function RadioForm(_ref2) {
  var question = _ref2.question,
      result = _ref2.result;

  var _useContext = (0, _react.useContext)(_quizz.QuizzContext),
      _useContext2 = _slicedToArray(_useContext, 2),
      state = _useContext2[0],
      dispatch = _useContext2[1];

  if (state.currentQuestion.type !== "bool") {
    // Ce test ne sert qu'à utiliser explicitement "state"
    // pour ne pas avoir d'erreur "unused-var" en console
    console.log("erreur: form inadapté au type de question en cours");
  }

  var _handleChange = function handleChange(value) {
    // console.log("on click", value)
    if (result && result.response_id) {
      dispatch({
        type: "UPDATE_BOOL_RESULT",
        value: value
      });
    } else {
      dispatch({
        type: "SET_BOOL_RESULT",
        value: value
      });
    }
  };

  return question.choices && question.choices.map(function (c) {
    return _react["default"].createElement(InputRadio, {
      choice: c,
      key: c.id,
      checked: result && result.response_id === c.id,
      handleChange: function handleChange(_ref3) {
        var value = _ref3.target.value;
        return _handleChange(value);
      }
    });
  });
};

var _default = RadioForm;
exports["default"] = _default;